<template>
  <div class="product-info">
    <jimi-card v-if="serviceData" :title="$t('HT.advancedService.userInfo')">
      <jimi-card-item :label="$t('HT.user.id')">{{ serviceData.userId }}</jimi-card-item>
      <jimi-card-item :label="$t('HT.advancedService.userAccount')">{{ serviceData.userAccount }}</jimi-card-item>
      <jimi-card-item :label="$t('HT.advancedService.userName')">{{ serviceData.userName }}</jimi-card-item>
      <jimi-card-item :label="$t('HT.advancedService.sourcePlatform')">{{ serviceData.source }}</jimi-card-item>
      <jimi-card-item :label="$t('HT.voltageInfo.time')">{{ serviceData.time }}</jimi-card-item>
    </jimi-card>
    <jimi-card v-if="detailData" :title="$t('HT.advancedService.orderService')">
      <ux-table ref="table" :showPage="false" :data="detailData.userDetailStrategys" :total="tableData.totalSize"
        :columns="columns" :emptyText="$t('HT.nodata')" layout="total, sizes, prev, pager, next"></ux-table>
    </jimi-card>
    <template v-if="chartOption.length">
      <line-chart v-for="(option, index) of chartOption" :option="option" :el="'echart-wrap' + index" :index="index"
        @change="changeChart" />
    </template>
  </div>
</template>

<script lang="jsx">
import lineChart from '../components/lineChart';
export default {
  components: {
    lineChart,
  },
  data() {
    return {
      isShow: true,
      detailData: null,
      serviceData: null,
      // 表的数据
      tableData: {
        totalSize: 0,
        list: []
      },
      columns: [
        {
          label: this.$t('HT.advancedService.strategyId'),
          prop: 'strategyId',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.orderId'),
          prop: 'orderId',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.serviceName'),
          prop: 'serviceName',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.serviceType'),
          prop: 'serviceType',
          align: 'left',
          tooltip: true,
        },

        {
          label: this.$t('HT.advancedService.serviceStatus'),
          prop: 'strategyStatus',
          align: 'left',
          tooltip: true,
          render: (h, data) => <span class="form-val" style={{ color: ['', '#3DC456', '#E6A23C', '#F45C5C'][data.strategyStatus] }}>{this.$opt.switchStr(data.strategyStatus, this.$opt.serviceStatus)}</span>
        },
        {
          label: this.$t('HT.advancedService.quato'),
          prop: 'quato',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.addLicense.expireDate'),
          prop: 'first_call_time',
          align: 'left',
          tooltip: true,
          render: (h, data) => <div>
            <p>{this.$t('HT.advancedService.effective')}：{data.orderStartTime}</p>
            <p>{this.$t('HT.advancedService.expired')}：{data.orderEndTime}</p>
          </div>
        },

        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(92),
          align: 'left',
          width: 120,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [
                  this.$t('HT.common.detail'),
                ],
                className: [
                  '',
                  this.userData.supervisor && params.published != 2 ? '' : 'no-click',
                  params.published == 0 ? 'no-click' : '',
                  ''
                ],
                event: ['goToDetail']
              },
              on: {
                // 管理
                goToDetail: () => {
                  this.goToDetail(params);
                },

              }
            });
          }
        }
      ],
      chartOption: [],
    };
  },
  mounted() {
    this.userData = this.$store.state.login.userData;
    this.getDetail()
  },
  methods: {
    async getDetail() {
      let { code, data } = await this.$api.advancedService.getUserDetail({ userId: this.$route.query.userId, source: this.$route.query.source })
      if (code == 10000) {
        this.detailData = data;
        this.serviceData = data;
        if (this.detailData.userDetailStrategys) {
          this.detailData.userDetailStrategys.map(async ({ strategyId, serviceName }) => {
            let data = await this.getChartData({ strategyId });
            this.setChartData({ list: data, product_id:strategyId, product_name:serviceName });
          });

        }

      }

    },
    async getChartData({ strategyId, product_id, dateType = '1', startTime = '', endTime = '' }) {
      let params = {
        strategyId: strategyId || product_id,
        dateType,
        startTime,
        endTime,
      };
      let { data } = await this.$api.advancedService.getStrategyReport(params);
      return data;
    },



    async updateQuato(quato) {
      let params = {
        strategyId: this.$route.query.id,
        quato,
      };
      const { code } = await this.$api.advancedService.updateQuato(params);
      if (code === 10000) {
        this.$uxModal.hide();
        this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
        this.getDetail()
      }

    },

    setChartData(data, index) {
      const { product_id, product_name, list } = data
      const xAxisData = list.map(item => item.date);
      const seriesData = list.map(item => item.count);
      let obj = {
        title: product_name + '-' + product_id,
        xAxisData,
        seriesData,
        product_id,
        product_name
      };
      if (index !== undefined) {
        this.$set(this.chartOption, index, obj);
      } else {
        this.chartOption.push(obj);
      }

    },

    async changeChart({ index, ...rest }) {
      let data = await this.getChartData(rest);
      this.setChartData({ list: data,...rest  }, index);
    },
    goToDetail(params) {
      this.$router.push({ path: '/advancedService/detail', query: { id: params.strategyId } });
    },

  }
};
</script>

<style lang="scss" scoped>
.product-info {
  padding-bottom: 20px;

  .info-content {
    .api_words {
      margin: 0 0 10px 0;
    }
  }
}

.text-color {
  color: #0087ff;
  cursor: pointer;
}
</style>
